import brandingProduction from "../../Images/ourServices/BRANDING-icon.png";
import creativeDevelopmentPromotional from "../../Images/ourServices/CREATIVE-DEV-icon.png";
import events from "../../Images/ourServices/EO-icon.png";
import talent from "../../Images/ourServices/KOL-icon.png";
import outOfHome from "../../Images/ourServices/OOH-icon.png";
import promotional from "../../Images/ourServices/POSM-icon.png";
import printedMaterial from "../../Images/ourServices/PRINTED-icon.png";
import socialMediaManagement from "../../Images/ourServices/SMM-icon.png";
import Product1 from "../../Images/webp/PRODUK-1.webp";
import Product10 from "../../Images/webp/PRODUK-10.webp";
import Product11 from "../../Images/webp/PRODUK-11.webp";
import Product12 from "../../Images/webp/PRODUK-12.webp";
import Product13 from "../../Images/webp/PRODUK-13.webp";
import Product2 from "../../Images/webp/test2.png";
import Product3 from "../../Images/webp/PRODUK-3.webp";
import Product4 from "../../Images/webp/PRODUK-4.webp";
import Product5 from "../../Images/webp/PRODUK-5.webp";
import Product6 from "../../Images/webp/PRODUK-6.webp";
import Product7 from "../../Images/webp/PRODUK-7.webp";
import Product8 from "../../Images/webp/PRODUK-8.webp";
import Product9 from "../../Images/webp/PRODUK-9.webp";
import oohSGM from "../../Images/webp/billboard-sgm.webp";
import oohSweety from "../../Images/webp/billboard-sweety.webp";
import brandingPro from "../../Images/webp/brandingPro.webp";
import creDev1 from "../../Images/webp/creative-dev.webp";
import creDev2 from "../../Images/webp/creative-dev2.webp";
import evEnt from "../../Images/webp/eventz-1.webp";
import evEnt2 from "../../Images/webp/eventz-2.webp";
import inFlue from "../../Images/webp/influencers-1.webp";
import inFlue2 from "../../Images/webp/influencers-2.webp";
import OOh2 from "../../Images/webp/ooh-1.webp";
import OOh from "../../Images/webp/ooh-2.webp";
import OOh3 from "../../Images/dancow.jpg";
import OOh4 from "../../Images/dancow2.jpg";
import OOh5 from "../../Images/lactogrow.jpg";
import OOh6 from "../../Images/lactogrownight.jpg";
import OOh7 from "../../Images/aquaooh.jpg";
import OOh8 from "../../Images/aquaooh2.jpeg";
import OOh9 from "../../Images/ooh9.webp";


import posm1 from "../../Images/aquaposm.jpg";
import posm2 from "../../Images/aquapsm2.jpg";
import posm3 from "../../Images/moviposm.jpg";
import posm4 from "../../Images/relxposm.jpg";
import posm5 from "../../Images/mildposm.jpg";
import posm6 from "../../Images/sampahposm.jpg";
import posm7 from "../../Images/sampahposm2.jpg";

import b1 from "../../Images/astrab1.jpg";
import b2 from "../../Images/astrab2.jpg";
import b3 from "../../Images/astrab3.jpg";
import b4 from "../../Images/bebelacb1.jpg";
import b5 from "../../Images/bebelacb2.jpg";
import b6 from "../../Images/bebelacb3.jpg";
import b7 from "../../Images/bebelacb4.jpg";
import b8 from "../../Images/sgmb1.jpg";
import b9 from "../../Images/sociollab1.jpg";
import b10 from "../../Images/sociollab2.jpg";
import b11 from "../../Images/sociollab3.jpg";
import b12 from "../../Images/sociollab4.jpg";
import b13 from "../../Images/sociollab5.jpg";
import b14 from "../../Images/polrib1.jpg";
import b15 from "../../Images/astrab4.jpeg";
import b16 from "../../Images/astrab5.jpeg";
import b17 from "../../Images/aquab1.jpg";
import b18 from "../../Images/aquab2.jpg";
import b19 from "../../Images/aquab3.jpg";

import eo1 from "../../Images/eo1.png";
import eo2 from "../../Images/eo2.jpg";
import eo3 from "../../Images/eo3.jpg";
import eo4 from "../../Images/eo4.jpg";

import pm1 from "../../Images/pm1.jpg";
import pm2 from "../../Images/pm2.png";
import pm3 from "../../Images/pm3.jpg";

import crede1 from "../../Images/crede1.png";
import crede2 from "../../Images/crede2.png";

import printMat from "../../Images/webp/printedmaterials.webp";
import printMat2 from "../../Images/webp/printedmaterials2.webp";
import promUnit from "../../Images/webp/promotional-units.webp";
import promUnit2 from "../../Images/webp/promotional-units2.webp";
import soCial from "../../Images/webp/socmed.webp";
import soCial2 from "../../Images/webp/socmed2.webp";

export default [
  {
    name: "Out Of Home",
    textNotBold: "Out Of",
    textBold: "Home",
    cover: outOfHome,
    ava: oohSGM,
    texts: "Nationwide",
    textsId: "Skala Nasional",
    quotes: "read more",
    description:
      "We understand the importance of choosing the best plan to promote your business. We can help you choose the most efficient ad placements within your price range to boost your exposure. For brands wishing to advertise in urban areas and drive significant traffic through our advertising platforms, our many OOH platforms offer nationwide coverage.",
    descriptionId:
      "Kami paham pentingnya memilih rencana terbaik untuk mempromosikan bisnis anda. Kami dapat membantumu memilih peletakan iklan paling efektif dalam jangkauan budget Anda untuk meningkatkan exposure sebanyak mungkin. Untuk brand yang ingin mempromosikan produknya di berbagai area perkotaan dan mendatangkan hasil yang signifikan, kami menyediakan layanan Out of Home (OOH) yang menjangkau seluruh negeri.",
    ava2: oohSweety,
    products: [
      {
        img: OOh2,
        title: "SGM Eksplor",
      },
      {
        img: OOh,
        title: "Camel",
      },
      {
        img: OOh3,
        title: "dancow",
      },
      {
        img: OOh4,
        title: "dancow",
      },
      {
        img: OOh5,
        title: "lactogrow",
      },
      {
        img: OOh6,
        title: "lactogrow",
      },
      {
        img: OOh7,
        title: "lactogrow",
      },
      {
        img: OOh8,
        title: "lactogrow",
      },
      {
        img: OOh9,
        title: "lactogrow",
      },
    ],
  },
  {
    name: "Promotional Units",
    textNotBold: "Units (POSM)",
    textBold: "Promotional",
    cover: promotional,
    ava: promUnit,
    texts: "Paper, Woods, Acrylic, Metal based",
    textId: "Paper, Woods, Acrylic, Metal based",
    quotes: "read more",
    description:
      "We help businesses produce variants of promotional materials that successfully convey the product's USP to customers. The fundamental objective is to increase consumer awareness of the product, attract them in, and convince them to choose it above the competitors.",
    descriptionId:
      "Kami membantu banyak bisnis menghasilkan berbagai kebutuhan promosi untuk menonjolkan USP dari produk Anda ke pelanggan. Tujuan dasar kami adalah untuk meningkatkan kepekaan pelanggan terhadap produknya, menarik mereka, dan meyakinkan bahwa produk tersebut lebih baik daripada kompetitornya.",
    ava2: promUnit2,
    products: [
      {
        img: Product1,
        title: "Kitchen",
      },
      {
        img: Product2,
        title: "Kitchen",
      },
      {
        img: Product3,
        title: "Meeting Room",
      },
      {
        img: Product4,
        title: "Kitchen",
      },
      {
        img: Product5,
        title: "Work Room",
      },
      {
        img: Product6,
        title: "Work Room",
      },
      {
        img: Product7,
        title: "Work Room",
      },
      {
        img: Product8,
        title: "Work Room",
      },
      {
        img: Product9,
        title: "Work Room",
      },
      {
        img: Product10,
        title: "Work Room",
      },
      {
        img: Product11,
        title: "Work Room",
      },
      {
        img: Product12,
        title: "Work Room",
      },
      {
        img: Product13,
        title: "Work Room",
      },
      {
        img: posm1,
        title: "Kitchen",
      },
      {
        img: posm2,
        title: "Kitchen",
      },
      {
        img: posm3,
        title: "Meeting Room",
      },
      {
        img: posm4,
        title: "Kitchen",
      },
      {
        img: posm5,
        title: "Work Room",
      },
      {
        img: posm6,
        title: "Work Room",
      },
      {
        img: posm7,
        title: "Work Room",
      },
      {
        img: posm7,
        title: "Work Room",
      },
    ],
  },
  // {
  //   name: "Talent & KOL Management ",
  //   textNotBold: "Talent & KOL",
  //   textBold: "Management",
  //   cover: talent,
  //   ava: inFlue,
  //   texts: "Bringing you the best brand deals",
  //   textsId: "Bringing you the best brand deals",
  //   quotes: "read more",
  //   description:
  //     "The effectiveness of word-of-mouth marketing can influence consumers behavior and engagement in the buying process. Influencers now control a large part of consumer behavior and brand perception today. Therefore, it is important to find influencers who match your needs.  We will help you find the best talent, KOLs, and influencers for any marketing campaign. We don't just recruit the best, we also assist you in managing the talent and ensuring the highest quality of all results.",
  //   descriptionId:
  //     "Efektivitas pemasaran secara word-of-mouth dapat mempengaruhi perilaku pelanggan dan menarik mereka dalam proses transaksi. Di masa sekarang, influencer dapat mengontrol perilaku pelanggan dalam jumlah besar dan memberikan persepsi brand pada pelanggan. Oleh karena itu, sangat penting untuk menemukan influencer-influencer yang sesuai dengan kebutuhan Anda. Kami akan membantu Anda menemukan talent, KOL, dan influencer-influencer terbaik untuk kebutuhan pemasaran apa pun. Kami tidak hanya melakukan perekrutan dari yang terbaik, namun kami juga membantu anda untuk memanajemen talent-talent tersebut dan memastikan adanya hasil yang maksimal.",
  //   ava2: inFlue2,
  //   products: [],
  // },
  {
    name: "Events Organizer",
    textBold: "Event",
    textNotBold: "Organizer",
    cover: events,
    ava: evEnt,
    texts: "Indoor, Outdoor, and Digital events",
    textsId: "Indoor, Outdoor, and Digital events",
    quotes: "read more",
    description:
      "Events can be used to create a personal and engaging environment with your current and new customers. Direct company-to-customer interactions at events are a great way to make a lasting impression. Successful events create strong bonds between customers, potential customers, consumers, and the company itself. Beyond product launches, you can host corporate and social events to make your brand shine and stand out.",
    descriptionId:
      "Acara-acara yang Anda selenggarakan dapat membantu menciptakan lingkungan yang personal dan menarik terhadap pelanggan dan calon pelanggan Anda. Hubungan langsung antara perusahaan dengan pelanggan saat acara berlangsung adalah cara yang baik untuk menimbulkan kesan yang mendalam. Suatu acara yang sukses dapat meningkatkan ikatan antar pelanggan, calon pelanggan, dan perusahaanna sendiri. Melalui peluncuran produk, Anda dapat membuat acara sosial dan perusahaan untuk membuat brand Anda semakin bersinar.",
    ava2: evEnt2,
    products: [
      {
        img: eo1,
        title: "Kitchen",
      },
      {
        img: eo2,
        title: "Kitchen",
      },
      {
        img: eo3,
        title: "Meeting Room",
      },
      {
        img: eo4,
        title: "Kitchen",
      },
    ],
  },
  {
    name: "Digital Marketing",
    textNotBold: "Marketing",
    textBold: "Digital",
    cover: socialMediaManagement,
    ava: soCial,
    texts:
      "We support brands to increase their brand awareness on a social media platform and bringing you the best brand deals.",
    textsId:
      "We support brands to increase their brand awareness on a social media platform and bringing you the best brand deals.",
    quotes: "read more",
    description:
      "A crucial component of spreading brand awareness to your audience at the moment is having innovative content. Creating engaging content also boosts audience trust and conversions across all media. Our services will guide you through the three stages of managing social media: strategy planning, post and content management, monitoring, and reporting. \n The effectiveness of word-of-mouth marketing can influence consumers behavior and engagement in the buying process. Influencers now control a large part of consumer behavior and brand perception today. Therefore, it is important to find influencers who match your needs.  We will help you find the best talent, KOLs, and influencers for any marketing campaign. We don't just recruit the best, we also assist you in managing the talent and ensuring the highest quality of all results.",
    descriptionId:
      "Komponen penting untuk menyebarkan brand awareness pada calon pelanggan Anda adalah melalui konten yang inovatif. Pembuatan konten yang menarik juga meningkatkan kepercayaan dan konversi pelanggan Anda. Pelayanan kami akan membantu Anda melalui 3 langkah memanajemen sosial media: perencanaan strategi, manajemen konten, serta monitoring dan reporting. \n Efektivitas pemasaran secara word-of-mouth dapat mempengaruhi perilaku pelanggan dan menarik mereka dalam proses transaksi. Di masa sekarang, influencer dapat mengontrol perilaku pelanggan dalam jumlah besar dan memberikan persepsi brand pada pelanggan. Oleh karena itu, sangat penting untuk menemukan influencer-influencer yang sesuai dengan kebutuhan Anda. Kami akan membantu Anda menemukan talent, KOL, dan influencer-influencer terbaik untuk kebutuhan pemasaran apa pun. Kami tidak hanya melakukan perekrutan dari yang terbaik, namun kami juga membantu anda untuk memanajemen talent-talent tersebut dan memastikan adanya hasil yang maksimal.",
    ava2: soCial2,
    products: [],
  },
  {
    name: "Branding Production",
    textBold: "Branding",
    textNotBold: "Production",
    cover: brandingProduction,
    ava: brandingPro,
    texts: "All business owners are aware of how crucial exhibitions are to their sales approach.",
    textId: "All business owners are aware of how crucial exhibitions are to their sales approach.",
    quotes: "read more",
    description:
      "Branding is more than simply a logo. The brand soul should be included into every aspect of every production, and branding affects visibility overall. We assist you in managing your branding so that all of your brand values may be applied to the products you design to make your brand stand out and be top-of-mind.",
    descriptionId:
      "Branding lebih dari sekadar logo. Nyawa dari suatu brand harus dapat tercantum dalam setiap aspek produksi dan mempengaruhi tampilan secara menyeluruh. Kami akan membantu Anda dalam mengurus branding dan mengaplikasikan nilai-nilai dari brand Anda pada produk yang Anda desain sehingga brand Anda dapat tampil menjadi yang utama di pasaran.",
    ava2: brandingPro,
    products: [
      {
        img: Product1,
        title: "Kitchen",
      },
      {
        img: Product2,
        title: "Kitchen",
      },
      {
        img: Product3,
        title: "Meeting Room",
      },
      {
        img: Product4,
        title: "Kitchen",
      },
      {
        img: Product5,
        title: "Work Room",
      },
      {
        img: Product6,
        title: "Work Room",
      },
      {
        img: Product7,
        title: "Work Room",
      },
      {
        img: Product8,
        title: "Work Room",
      },
      {
        img: Product9,
        title: "Work Room",
      },
      {
        img: Product10,
        title: "Work Room",
      },
      {
        img: Product11,
        title: "Work Room",
      },
      {
        img: Product12,
        title: "Work Room",
      },
      {
        img: Product13,
        title: "Work Room",
      },
      {
        img: b1,
        title: "Kitchen",
      },
      {
        img: b2,
        title: "Kitchen",
      },
      {
        img: b3,
        title: "Meeting Room",
      },
      {
        img: b4,
        title: "Kitchen",
      },
      {
        img: b5,
        title: "Work Room",
      },
      {
        img: b6,
        title: "Work Room",
      },
      {
        img: b7,
        title: "Work Room",
      },
      {
        img: b8,
        title: "Work Room",
      },
      {
        img: b9,
        title: "Work Room",
      },
      {
        img: b10,
        title: "Work Room",
      },
      {
        img: b11,
        title: "Work Room",
      },
      {
        img: b12,
        title: "Work Room",
      },
      {
        img: b13,
        title: "Work Room",
      },
      {
        img: b14,
        title: "Work Room",
      },
      {
        img: b15,
        title: "Work Room",
      },
      {
        img: b16,
        title: "Work Room",
      },
      {
        img: b17,
        title: "Work Room",
      },
      {
        img: b18,
        title: "Work Room",
      },
      {
        img: b19,
        title: "Work Room",
      },
  ],
  },
  {
    name: "Creative Dev Promo Units",
    textNotBold: "Creative Dev",
    textBold: "Promo Units",
    cover: creativeDevelopmentPromotional,
    ava: creDev1,
    texts:
      "Give you a creative recommendation to promote your brand's campaign",
    textsId:
      "Give you a creative recommendation to promote your brand's campaign",
    quotes: "read more",
    description:
      "Stands out and unique branding can attract loyal customers. Manufacturing branding goes beyond simply portraying to customers the values of your business. It's important to share with your customer the importance of making a high-quality product.\nEffective branding can make your brand more relevant and personal. As brand awareness steadily evolves into loyalty, customers will begin to trust your product as a key differentiator from your competitors.\nEvery entrepreneur understands that product presentation is vital for their sales strategy.  We are here to help you maximize the visibility of your branding booth and POSM while keeping your budget in check.",
    descriptionId:
      "Suatu branding yang menonjol dan unik dapat menarik pelanggan setia. Pembuatan suatu branding tidak hanya berhenti saat pelanggan tahu apa bisnis yang Anda jalankan. Penting untuk membagikan pada pelanggan Anda mengenai kebutuhan akan produk dengan kualitas tinggi.\nBranding yang efektif dapat membuat brand Anda lebih relevan dan personal. Setelah calon pelanggan yang peka berubah menjadi pelanggan setia, mereka akan mulai mempercayai produk Anda sebagai sesuatu yang berbeda dari kompetitor-kompetitor Anda.\nSetiap pengusaha paham akan pentingnya tampilan produk terhadap strategi penjualannya. Kami di sini membantu anda untuk memaksimalkan penampilan dari branding booth dan POSM Anda dengan tetap memperhatikan budget yang Anda sediakan.",
    ava2: creDev2,
    products: [
      {
        img: crede1,
        title: "Work Room",
      },
      {
        img: crede2,
        title: "Work Room",
      },
    ],
  },
  {
    name: "Printed Material",
    textNotBold: "Material",
    textBold: "Printed",
    cover: printedMaterial,
    ava: printMat,
    texts: "Offset, Screen Print, and Digital Print",
    textId: "Offset, Screen Print, and Digital Print",
    quotes: "read more",
    description:
      "The content's core is just as important as the printing. Our expert creative team will support the brand with any copywriting, graphic design, editing, and web development suggestions. Additionally, a number of printing machines are ready to print all the documents and help your business stand out from the competition.",
    descriptionId:
      "Kebutuhan akan konten sama pentingnya dengan percetakan. Tim kreatif kami yang berpengalaman akan membantu memberikan sugesti terhadap kebutuhan copywriting, desain grafis, editing, dan pembuatan situs website untuk brand Anda. Lalu, berbagai mesin cetak kami akan siap untuk mencetak seluruh kebutuhan Anda dan membantu bisnis anda tampil menonjol dibanding kompetitor lain.",
    ava2: printMat2,
    products: [
      {
        img: pm1,
        title: "Work Room",
      },
      {
        img: pm2,
        title: "Work Room",
      },
      {
        img: pm3,
        title: "Work Room",
      },
    ],
  },
];
